/*
 * Desktop nav "priority+" overflow.
 * Keeps .header__inline-menu on ONE row: measures the list on load, font load
 * and resize; top-level items that overflow are hidden (from the right) and
 * mirrored inside the "Více" dropdown rendered by header-nav-more-dropdown.liquid.
 * Mirrored entries are plain links, or an accordion of level-2 links when the
 * item has a mega/dropdown submenu. Does nothing below 990px (mobile drawer).
 */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var CARET =
    '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>';

  function textOf(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /* Build the entry shown inside "Více" for one top-level <li>. */
  function buildEntry(li) {
    var control = li.querySelector(':scope > header-menu summary, :scope > a.header__menu-item');
    if (!control) return null;
    var title = textOf(control.querySelector('span')) || textOf(control);
    var url = control.tagName === 'A' ? control.getAttribute('href') : control.getAttribute('data-url');
    var sublinks = Array.prototype.slice.call(
      li.querySelectorAll('.mega-menu__link--level-2, .header__submenu > li > a')
    ).filter(function (a) {
      return !a.closest('.mega-menu__tile--all');
    });

    var entry = document.createElement('li');
    entry.className = 'header__nav-more-item';

    if (!sublinks.length) {
      var link = document.createElement('a');
      link.className = 'header__nav-more-link link';
      link.href = url || '#';
      link.textContent = title;
      entry.appendChild(link);
      return entry;
    }

    var details = document.createElement('details');
    var summary = document.createElement('summary');
    summary.className = 'header__nav-more-link';
    summary.innerHTML = '<span></span>' + CARET;
    summary.firstChild.textContent = title;
    var sub = document.createElement('ul');
    sub.className = 'header__nav-more-sub list-unstyled';
    sub.setAttribute('role', 'list');
    sublinks.forEach(function (a) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.className = 'link';
      link.href = a.getAttribute('href');
      link.textContent = textOf(a);
      item.appendChild(link);
      sub.appendChild(item);
    });
    if (url) {
      var all = document.createElement('li');
      var allLink = document.createElement('a');
      allLink.className = 'link header__nav-more-all';
      allLink.href = url;
      allLink.textContent = 'Zobrazit vše';
      all.appendChild(allLink);
      sub.appendChild(all);
    }
    details.appendChild(summary);
    details.appendChild(sub);
    entry.appendChild(details);
    return entry;
  }

  function init(nav) {
    var list = nav.querySelector('.list-menu--inline');
    var moreLi = list && list.querySelector(':scope > .header__nav-more');
    if (!list || !moreLi) return;
    var moreList = moreLi.querySelector('.header__nav-more-list');
    var moreDetails = moreLi.querySelector('details');
    var items = Array.prototype.filter.call(list.children, function (li) {
      return li !== moreLi;
    });
    var entries = items.map(buildEntry);
    var frame = 0;

    function closeMore() {
      if (moreDetails && moreDetails.open) moreDetails.removeAttribute('open');
    }

    function reset() {
      items.forEach(function (li) {
        li.hidden = false;
      });
      entries.forEach(function (e) {
        if (e && e.parentNode) e.parentNode.removeChild(e);
      });
      closeMore();
      moreLi.hidden = true;
    }

    function fits() {
      return list.scrollWidth <= list.clientWidth + 1;
    }

    function update() {
      reset();
      if (!DESKTOP.matches || fits()) return;
      moreLi.hidden = false;
      for (var i = items.length - 1; i >= 0 && !fits(); i--) {
        items[i].hidden = true;
        if (entries[i]) moreList.insertBefore(entries[i], moreList.firstChild);
      }
    }

    function schedule() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(nav);
    } else {
      window.addEventListener('resize', schedule);
    }
    DESKTOP.addEventListener('change', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    update();
  }

  document.querySelectorAll('.header__inline-menu').forEach(init);
})();
